import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Alert, Spinner, useAsync } from '@wix/cli-ui-kit';
import { useMultilingualClient } from '@wix/multilingual-client';
import {
  TRANSLATIONS_DIR,
  getTranslationsDir,
} from '@wix/cli-astro-definitions';
import { useProjectModel } from '../../model.js';
import { saveTranslationFiles } from './save-translation-files.js';

export const TranslationPull: FC<{ onComplete?: () => void }> = ({
  onComplete,
}) => {
  const { model } = useProjectModel();
  const multilingualClient = useMultilingualClient();

  const { status } = useAsync(async () => {
    const [translationsByLanguage, primaryLanguage] = await Promise.all([
      multilingualClient.pullAllTranslations(),
      multilingualClient.getPrimaryLanguage(),
    ]);

    const translationsDir = getTranslationsDir(model.projectFolder);

    await saveTranslationFiles(
      translationsDir,
      translationsByLanguage,
      primaryLanguage
    );

    onComplete?.();
  }, []);

  return match(status, {
    Loading: () => <Spinner text="Pulling translation files..." />,
    Success: () => {
      return (
        <Alert type="success">
          Translation files written to "{TRANSLATIONS_DIR}"
        </Alert>
      );
    },
    Error: () => null,
    NotRequested: () => null,
  });
};
